import React, { useState } from "react";
import Dropzone from "react-dropzone";

// Breadcrumb

import { Icon } from "@iconify/react/dist/iconify.js";
import { Box, ButtonBase, Chip, FormHelperText, Grid, Typography } from "@mui/material";
import Helpers from "../../helpers/helpers";
import AppAttachmentDialog from "../Common/AppAttachmentDialog";
import CustomButton from "./CustomButton";
import AppEditImage from "../Common/AppEditImage";
import RenderPopOverButton from "./RenderPopOverButton";
import Label from "../Common/Label";

export default function UploadProductImagesNew({ maxFileSize = 10, maxFile = 10, xs = 12, sm = 6, md = 6, title, isOptional, setFormValues, images, multiple, setNotification, values, error, errorName, showLimit = true, disabled, windowWidth, handleThumbnail }) {
    const [attachmentOpen, setAttachmentOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [editImageOpen, setEditImageOpen] = useState(false);

    const handleAcceptedFiles = async (files) => {
        const MAX_FILE_SIZE = parseInt(maxFileSize) * 1024 * 1024; // 10 MB in bytes
        const MAX_PHOTOS = parseInt(maxFile); // Maximum number of photos allowed

        const currentPhotoCount = values?.length || 0;
        const remainingSlots = MAX_PHOTOS - currentPhotoCount;

        if (remainingSlots <= 0 || files?.length > MAX_PHOTOS) {
            setNotification({
                open: true,
                msg: `You can only upload up to ${MAX_PHOTOS} photos.`,
                type: "warning",
            });
            return; // Stop processing
        }
        // Filter oversized files
        const oversizedFiles = files.filter((file) => file.size > MAX_FILE_SIZE);
        const validFiles = files.filter((file) => file.size <= MAX_FILE_SIZE);

        if (oversizedFiles.length > 0) {
            setNotification({
                open: true,
                msg: `Some files are too large (max 10 MB). Please check and try again.`,
                type: "warning",
            });
        }

        if (validFiles.length === 0) {
            return; // No valid files to process
        }

        // Restrict the number of files to the remaining slots
        const filesToProcess = validFiles.slice(0, remainingSlots);

        if (validFiles.length > remainingSlots) {
            setNotification({
                message: `Only ${remainingSlots} more photos can be uploaded.`,
                type: "error",
            });
        }
        try {
            if (filesToProcess.length > 0) {
                let temp = values ? [...values] : [];

                await Promise.all(filesToProcess.map((file) => {
                    return new Promise((resolve) => {
                        const fileName = file?.name;
                        Helpers.getPreviewBase64(file, (result) => {
                            const fileFormat = Helpers.getFileExtension(result);
                            const fileSize = Helpers.formatBytes(file.size);
                            temp.push({
                                file_path: URL.createObjectURL(file),
                                file_base64: result,
                                file_name: fileName,
                                file_format: fileFormat,
                                file_size: fileSize,
                                is_thumbnail: handleThumbnail ? temp.length === 0 : false // Set the first uploaded image as thumbnail by default
                            });
                            resolve();
                        });
                    });
                }));
                setFormValues(temp);
            }

        } catch (error) {
            console.error("Error converting files:", error);
        }
    };

    const handleDeleteFilesTemp = (index) => {
        const filteredFile = values.filter((item, idx) => idx !== index)
        setFormValues(filteredFile, index)
    }

    const handleCropImage = (croppedImage) => {
        let currentImageIndex = values.findIndex((item) => item.file_base64 === selectedFile.file_base64);
        if (currentImageIndex !== -1) {
            let updatedImages = [...values];
            updatedImages[currentImageIndex].file_base64 = croppedImage;
            setFormValues(updatedImages);
        }
    }

    const handleEditImage = (file) => {
        setEditImageOpen(true);
        setSelectedFile(file);
    }

    const getImageActions = (file, idx) => {
        const items = [
            {
                label: 'Edit',
                iconName: 'ri:pencil-line',
                onClick: () => handleEditImage(file),
            },
            {
                label: 'Delete',
                iconName: 'ri:delete-bin-line',
                color: '#D13536',
                onClick: () => handleDeleteFilesTemp(idx),
            },
        ];

        if (handleThumbnail) {
            items.unshift({
                label: file?.is_thumbnail ? 'Unset thumbnail' : 'Set as thumbnail',
                iconName: file?.is_thumbnail ? 'ri:image-line' : 'ri:image-2-line',
                onClick: () => handleThumbnail(file, idx),
            });
        }

        return items;
    }

    const renderFile = (file, idx) => {
        return (
            <Grid item xs={xs} sm={sm} md={md} key={`attachment-file-${idx}`}>
                {
                    // maxFileSize === 1 ?
                    <Box style={{ width: 190, height: 120, position: 'relative' }}>
                        <img src={file.file_base64} alt={file.file_name} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                        {file?.is_thumbnail ? (
                            <div style={{ position: 'absolute', bottom: 5, right: 5 }}>
                                <Chip label={"Thumbnail"} style={{ color: "white", border: "1px solid white", backgroundColor: "#D13536", height: "20px", marginLeft: 2, marginBottom: 2 }} />
                            </div>
                        ) : ""}
                      {!disabled && <div className="position-absolute top-0 end-0 p-2" style={{ zIndex: 2 }}>
                            <RenderPopOverButton
                                items={getImageActions(file, idx)}
                                customTitle={
                                    <ButtonBase
                                        style={{ borderRadius: '100%', padding: 8, paddingInline: 10, backgroundColor: 'white' }}
                                    >
                                        <Icon icon={'ri:more-2-fill'} />
                                    </ButtonBase>
                                }
                            />
                        </div>}
                    </Box>
                    // : <Box className="attachment-container clickable" onClick={() => { handleOpenFile(file) }} style={{ position: 'relative' }}>
                    //     <div className="clickable" style={{ color: 'red', position: 'absolute', top: -10, right: -5 }} onClick={(e) => { e.stopPropagation(); handleDeleteFilesTemp(idx) }}>
                    //         <Icon icon={`ri-close-circle-fill`} style={{ height: 20, width: 20 }} />
                    //     </div>
                    //     <Grid container className="d-flex align-items-center">
                    //         <Grid item xs={2.5} >
                    //             {
                    //                 file.file_format === 'pdf' ?
                    //                     <Icon icon="ri-file-pdf-2-fill" color="#FA5E91" style={{ height: 35, width: 35 }} />
                    //                     : file.file_format === 'excel' || file.file_format === 'csv' || file.file_format === 'xls' || file.file_format === 'xlsx' || file.file_format === 'xlsm' ?
                    //                         <Icon icon="ri-file-excel-fill" color="#72BF78" style={{ height: 35, width: 35 }} />
                    //                         : file.file_format === 'mp4' ?
                    //                             <Icon icon="ri-video-fill" color="#000000ff" style={{ height: 35, width: 35 }} />
                    //                             : <img src={file.file_base64} alt={file.file_name} className="attachment-image-container" />

                    //             }
                    //         </Grid>
                    //         <Grid item xs={7.5}>
                    //             <Box
                    //                 sx={{
                    //                     overflow: 'hidden',
                    //                     whiteSpace: 'nowrap',
                    //                     textOverflow: 'ellipsis',
                    //                 }}
                    //             >
                    //                 {file.file_name}
                    //             </Box>
                    //             {/* <div className="subheader-2">{file.file_size}</div> */}
                    //         </Grid>
                    //         <Grid item xs={2} className="d-flex justify-content-end">
                    //             <div className="clickable" onClick={(e) => { e.stopPropagation(); handleDownload(file.file_base64, file.file_name) }}>
                    //                 <Icon icon="ri-download-cloud-line" color="#7D7D7D" style={{ height: 20, width: 20 }} />
                    //             </div>
                    //         </Grid>
                    //     </Grid>
                    // </Box>
                }

                {
                    error?.[errorName ? `${errorName}.${idx}.file` : `images.${idx}.image`] &&
                    <FormHelperText className='d-flex align-items-center' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.[errorName ? `${errorName}.${idx}.file` : `images.${idx}.image`] || ""}</FormHelperText>
                }
            </Grid >
        )
    }

    return (
        <React.Fragment>
            <Grid item xs={12} pb={1} style={{ fontFamily: 'FunnelSans', fontSize: 14, color: "#1D1B1B", fontWeight: 500 }}>
                {title} {isOptional ? <span className="optional-label">Optional</span> : null}
                {showLimit && (<span>({values?.length || 0}/{maxFile})</span>)}
            </Grid>
            <Grid item xs={12}>
                <div className="pb-3"
                >
                    {(!values || values.length === 0 || multiple) && !disabled && <Dropzone
                        accept={images ? {
                            'image/jpeg': ['.jpeg', '.jpg'],
                            'image/png': ['.png'],
                            'image/webp': ['.webp'],
                            'image/avif': ['.avif']
                        } :
                            {
                                "application/pdf": [],
                                "application/doc": [],
                                "application/docx": [],
                                "application/csv": [],
                                'image/jpeg': [],
                                'image/png': [],
                                ".xls": [],
                                ".xlsx": [],
                                "application/vnd.ms-excel": [],
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
                                ".csv": []
                            }
                        }
                        multiple={multiple || false}
                        onDrop={disabled ? () => { } : acceptedFiles =>
                            handleAcceptedFiles(acceptedFiles)
                        }
                        disabled={disabled}
                    >
                        {({ getRootProps, getInputProps }) => (
                            <div className="dropzone" style={{ backgroundColor: "#F3F3F380", minHeight: "250px", borderRadius: "8px", minWidth: "auto", display: "flex", justifyContent: "center", opacity: disabled ? 0.6 : 1, pointerEvents: disabled ? 'none' : 'auto', border: "1px solid #D9D9D9", borderStyle: 'dashed' }}>
                                <div
                                    className="dz-message needsclick"
                                    {...getRootProps()}
                                    style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}
                                >
                                    <input {...getInputProps()} disabled={disabled} />
                                    <div className="mb-2">
                                        <Icon icon={"ri-upload-cloud-2-line"} style={{ fontSize: "24px", color: "#1D1B1B" }} />
                                    </div>
                                    <Typography style={{ fontSize: "14px", color: "#1D1B1B", paddingBottom: "10px" }}>Upload or drag and drop an image</Typography>
                                    <CustomButton title={'Choose file'} textColor={'#1D1B1B'} backgroundColor={'white'} borderStyle={'1px solid #1D1B1B'} press={() => { }} />
                                </div>
                            </div>
                        )}
                    </Dropzone>}
                    {/* <FormHelperText sx={{ color: "#7D7D7D", paddingTop: "5px", fontSize: 14 }}>Recommended size not more than 5MB</FormHelperText> */}

                    {values && values?.length > 0 &&
                        <div style={{ boder: "1px dotted #d9d9d9" }}
                            className="dropzone-previews mt-3"
                            id="file-previews"
                        >
                            <Grid container spacing={2}>
                                {values && values?.length > 0 && values?.map((file, idx) => {
                                    return (renderFile(file, idx));
                                })}
                            </Grid>

                        </div>
                    }
                </div>
                <AppAttachmentDialog
                    open={attachmentOpen}
                    close={() => setAttachmentOpen(false)}
                    file={selectedFile?.file_base64}
                    fileName={selectedFile?.file_name}
                    filetype={selectedFile?.file_format}
                />
                <AppEditImage
                    title={'Edit Image'}
                    open={editImageOpen}
                    close={() => { setEditImageOpen(false); setSelectedFile(null); }}
                    image={selectedFile?.file_base64}
                    setImage={(e) => handleCropImage(e)}
                    isMobile={windowWidth <= 768}
                />
            </Grid>
        </React.Fragment >
    );
}
